// @flow

import withPage from 'hocs/page';

import { GlobalSearchModule } from './global-search-module';

export default withPage<any>(GlobalSearchModule);
